import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import HelpOptionButton from './HelpOptionButton';

const HelpTicketButton = () => {
  // Keep the component simple - just render our new component
  // that provides both tickets and feedback functionality
  return <HelpOptionButton />;
};

export default HelpTicketButton;
